export const isDevEnv = () => {
  return typeof window !== "undefined" &&
    (window.origin.includes("localhost") || window.origin.includes("dev") || window.origin.includes("test"))
    ? true
    : false;
};
